import React from 'react';

import Paper from '@mui/material/Paper';
import { useLiveQuery } from 'dexie-react-hooks';
import { v4 as uuid } from 'uuid';

import { DefineLiquidSetForm } from 'client/app/apps/disco-prototype/components/DefineLiquidSetForm';
import FlexContainer from 'client/app/apps/disco-prototype/components/FlexContainer';
import LiquidsetTable from 'client/app/apps/disco-prototype/components/LiquidsetTable';
import {
  discoPrototypeStore,
  Liquidset,
} from 'client/app/apps/disco-prototype/dataStore/dexieStore';

const Page = () => {
  const datasets = useLiveQuery(() => discoPrototypeStore.getDatasets(), []);
  const liquidsets = useLiveQuery(() => discoPrototypeStore.getLiquidsets(), []);
  const plates = useLiveQuery(() => discoPrototypeStore.getPlates(), []);
  const handleAddLiquidset = async (ls: Omit<Liquidset, 'id'>) => {
    await discoPrototypeStore.addLiquidset({
      id: uuid(),
      ...ls,
    });
  };

  if (!datasets || !liquidsets || !plates) return <div>Loading...</div>;

  return (
    <FlexContainer component={Paper}>
      <FlexContainer
        component={Paper}
        direction="column"
        sx={{ maxWidth: '400px', p: '16px 8px' }}
      >
        <DefineLiquidSetForm
          datasets={datasets}
          plates={plates}
          onSubmit={handleAddLiquidset}
        />
      </FlexContainer>
      <FlexContainer direction="column" sx={{ flex: 1 }}>
        <LiquidsetTable liquidsets={liquidsets} />
      </FlexContainer>
    </FlexContainer>
  );
};

export default Page;
